// extracted by mini-css-extract-plugin
export default {"promotion":"ImpersonationBanner_promotion__pXnWS","header-row":"ImpersonationBanner_header-row__yKxWN"};